import PropTypes from 'prop-types';

const certificateDetailsPropType = PropTypes.shape({
    gold: PropTypes.number,
    silver: PropTypes.number,
    bronze: PropTypes.number,
    goldBars: PropTypes.number,
    total: PropTypes.number
});

const pointsPropType = PropTypes.shape({
    activityPoints: PropTypes.number,
    livePoints: PropTypes.number,
    total: PropTypes.number
});

const accessDetailsPropType = PropTypes.shape({
    signIns: PropTypes.number,
    timeOnline: PropTypes.shape({
        hours: PropTypes.number,
        minutes: PropTypes.number
    })
});

const participationData = PropTypes.shape({
    classroomName: PropTypes.string,
    certificateDetails: certificateDetailsPropType,
    points: pointsPropType,
    accessDetails: accessDetailsPropType,
    classroomGroupParticipations: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            courseName: PropTypes.string,
            courseId: PropTypes.number,
            points: pointsPropType,
            accessDetails: accessDetailsPropType,
            certificateDetails: certificateDetailsPropType,
            studentUsageDetails: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.number,
                    fullName: PropTypes.string,
                    points: pointsPropType,
                    accessDetails: accessDetailsPropType,
                    certificates: certificateDetailsPropType
                })
            )
        })
    )
});

export default {
    participationData
};



// WEBPACK FOOTER //
// ./containers/participation/single-class/single-class-prop-types.js